// extracted by mini-css-extract-plugin
module.exports = {"value":"DurationField-value-Zvp2t","select":"DurationField-select-10YR8","unit":"DurationField-unit-1CrK_"};